module.exports = __webpack_public_path__ + "img/food.ea4e560d.svg";